// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"cafec43d","63":"8ee3b46a","90":"b21ef45a","330":"0599d550","334":"c12c4420","573":"a1d30a75","592":"adc327f2","604":"03b5b66e","639":"3cc7be2d","647":"2c52de6b","983":"bfa4a730"}[chunkId] + ".chunk.js";
};